<template>
  <div id="app" class="app" :class="className">
    <!-- TheSvgAssets -->
    <TheSvgAssets/>

    <!-- TheUdnLogo -->
    <TheUdnLogo
      link="https://udn.com/newmedia/election2020/poll"
      title="解密選舉數字"
      target="_blank"
      color="#1a1a1a"/>

    <!-- TheMenu -->
    <TheMenu
      project-id="poll"
      project-url="https://udn.com/newmedia/election2020/poll"
      title="看懂2020 - 解密選舉數字"
      hamburger-color="#1a1a1a"/>

    <main class="main">
      <router-view :key="$route.path"/>
    </main>
  </div>
</template>

<script>
import TheSvgAssets from '@/components/TheSvgAssets'
import debounce from '@/scripts/debounce'
import throttle from '@/scripts/throttle'
import { PROJECT_NAME, PROJECT_URL } from '@/constant'

export default {
  name: 'App',
  components: {
    TheSvgAssets
  },
  provide () {
    return {
      projectUrl: this.projectUrl,
      baseUrl: this.baseUrl,
      isDesktop: this.isDesktop,
      isMobile: this.isMobile,
      isInApp: this.isInApp
    }
  },
  data () {
    let baseUrl = process.env.BASE_URL
    if (baseUrl !== '/') {
      baseUrl = `${baseUrl}/`
    }
    let isDesktop = this.$device.desktop()
    let isMobile = this.$device.mobile()
    let isInApp = this.$inApp.isInApp
    return {
      projectName: PROJECT_NAME,
      projectUrl: PROJECT_URL,
      baseUrl,
      isDesktop,
      isMobile,
      isInApp,
      innerWidth: 0,
      innerHeight: 0,
      pageYOffset: 0,
      startDragPoint: null,
      lastDragPoint: null
    }
  },
  computed: {
    className () {
      let isNarrowDesktop = this.innerWidth >= 760 && this.innerHeight <= 768
      return {
        'narrow-desktop': isNarrowDesktop,
        'is-scroll-top': this.isScrollTop,
        'is-scroll-bottom': this.isScrollBottom
      }
    },
    isScrollTop () {
      return this.pageYOffset <= 0
    },
    isScrollBottom () {
      let bottom = document.body.clientHeight - this.innerHeight
      if (bottom <= 0) {
        return false
      }
      return this.pageYOffset >= bottom
    }
  },
  methods: {
    onResize: debounce(function () {
      this.syncViewportSize()
      this.$bus.$emit('resize', { width: this.innerWidth, height: this.innerHeight })
    }, 50),
    onScroll: throttle(function () {
      this.syncViewportScroll()
    }, 200),
    onLogoClick () {
      this.$router
        .push('/')
        .catch(err => err)
    },
    onDragStart (event) {
      let point = this.startDragPoint = this.detectDragPoint(event)
      document.addEventListener('touchmove', this.onDragMove)
      document.addEventListener('touchend', this.onDragStop)
      document.addEventListener('touchcancel', this.onDragStop)
      document.addEventListener('mousemove', this.onDragMove)
      document.addEventListener('mouseup', this.onDragStop)
      this.$bus.$emit('drag:start', { ...point })
    },
    onDragMove (event) {
      const point = this.lastDragPoint = this.detectDragPoint(event)
      this.$bus.$emit('drag:move', { ...point })
    },
    onDragStop (event) {
      document.removeEventListener('touchmove', this.onDragMove)
      document.removeEventListener('touchend', this.onDragStop)
      document.removeEventListener('touchcancel', this.onDragStop)
      document.removeEventListener('mousemove', this.onDragMove)
      document.removeEventListener('mouseup', this.onDragStop)
      const point = this.detectDragPoint(event)
      this.$bus.$emit('drag:stop', { ...point })
    },
    detectDragPoint (event, fromPageOrigin = false) {
      const isTouch = event.type.indexOf('touch') === 0
      const point = !isTouch ? event : event.touches[0] || event.changedTouches[0]
      if (!point) {
        return null
      }
      let x, y
      if (!fromPageOrigin) {
        x = point.clientX
        y = point.clientY
      } else {
        x = point.pageX
        y = point.pageY
      }
      return { x, y, isTouch }
    },
    syncViewportSize () {
      this.innerWidth = window.innerWidth
      this.innerHeight = window.innerHeight
    },
    syncViewportScroll () {
      this.pageYOffset = window.pageYOffset
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResize)
    window.removeEventListener('scroll', this.onScroll)
    window.removeEventListener('touchstart', this.onDragStart)
    if (!this.isMobile) {
      window.removeEventListener('mousedown', this.onDragStart)
    }
  },
  mounted () {
    window.addEventListener('resize', this.onResize)
    window.addEventListener('scroll', this.onScroll)
    window.addEventListener('touchstart', this.onDragStart)
    if (!this.isMobile) {
      window.addEventListener('mousedown', this.onDragStart)
    }
    this.syncViewportSize()
    this.syncViewportScroll()
  }
}
</script>

<style lang="scss">
.app {
  overflow-x: hidden;
}

.main {
  @include rwd($RWD_TABLET) {
    margin-right: 70px;
  }
}

.the-udn-logo {
  @include use-layer(&);
}

.the-menu {
  @include use-layer(&);
}
</style>
